export default __webpack_public_path__ + "static/thomas-hofmann-d55894002aba66d84c1722ce17e21b87.png";